import model from './model';
import rules from './rules';

export default (type, readonly) => {
  return {
    type,
    readonly,
    model: model(),
    rules: rules()
  };
};
